import { SpacesFeature } from '@/shared/types/Settings';
import { UpgradeAlert } from '@/shared/ui/UpgradeAlert';

import { getUpgradeAlertText } from '../lib/getUpgradeAlertText';

export type TeamspaceUpgradeAlertProps = {
  spacesFeature: SpacesFeature;
  onClick: () => void;
};

export const TeamspaceUpgradeAlert = ({ spacesFeature: spaceFeature, onClick }: TeamspaceUpgradeAlertProps) => {
  return <UpgradeAlert text={getUpgradeAlertText(spaceFeature)} onClick={onClick} />;
};
